// Media source-URL allowlist — client mirror of video-api
// (src/utils/sourceUrlAllowlist.js) and video-cms (src/lib/source-url-allowlist.ts).
// A media source_url must be a valid http(s) URL from one of these licensed
// providers; anything else is rejected. The backend enforces the same rule at
// commit — this is the UX gate so Save/Fetch are disabled before a round-trip.
//
// Kept dependency-free and Node-10/React-16 build safe (no optional chaining,
// no String.endsWith — slice compare instead).

// Narrowed to Getty / AP / BackGrid on 2026-08-26 — only these three carry a
// Source label, so anything else has no valid label and is refused at commit.
export var ALLOWED_SOURCE_DOMAINS = [
  "gettyimages.com",
  "newsroom.ap.org",
  "backgridusa.backgrid.com"
];

// Getty runs many regional domains (gettyimages.com/.in/.co.uk/.com.au/…). Allow
// any gettyimages.<tld> + subdomains; anchored so gettyimages.com.evil.com and
// notgettyimages.com do NOT match.
var GETTY_HOST_RE = /(^|\.)gettyimages\.[a-z]{2,}(\.[a-z]{2,})?$/;

// Parse a URL and return its lowercased hostname, or null if it isn't a valid
// http(s) URL.
function hostOf(raw) {
  if (!raw) return null;
  var s = String(raw).trim();
  if (!s) return null;
  var u;
  try {
    u = new URL(s);
  } catch (e) {
    return null;
  }
  if (u.protocol !== "http:" && u.protocol !== "https:") return null;
  return u.hostname.toLowerCase().replace(/\.$/, "");
}

// host === domain OR host ends with ".domain" (subdomain), without endsWith().
function hostMatches(host, domain) {
  if (host === domain) return true;
  var suffix = "." + domain;
  return host.length > suffix.length && host.slice(host.length - suffix.length) === suffix;
}

// True when `raw` is a syntactically valid http(s) URL.
export function isValidHttpUrl(raw) {
  return hostOf(raw) !== null;
}

// True when `raw` is a valid http(s) URL whose host is an approved provider.
export function isAllowedSourceUrl(raw) {
  var host = hostOf(raw);
  if (!host) return false;
  if (GETTY_HOST_RE.test(host)) return true;
  for (var i = 0; i < ALLOWED_SOURCE_DOMAINS.length; i++) {
    if (hostMatches(host, ALLOWED_SOURCE_DOMAINS[i])) return true;
  }
  return false;
}
